import Api from '@/models/Api'
import FinancialPlan from '@/models/FinancialPlan'
import MediaPlan from '@/models/MediaPlan'
import Opportunity from '@/models/Opportunity'
import SystemDashboardWidget from '@/models/SystemDashboardWidget'

import moment from 'moment'

export default class CPMOverview extends SystemDashboardWidget {
  public title: string = 'CPM Overview'

  public key: string = 'cpm-goal'

  public view: string = 'table'

  public noPagination: boolean = true

  public target = 'region'

  public getFieldTotal(key: string) {
    return this.data.reduce((acc: number, row: any) => acc + Number(row[key]), 0)
  }

  constructor(args: any = null) {
    super()

    if (args && args.dimensions) {
      this.dimensions = args.dimensions
    }

    if (args && args.metrics) {
      this.metrics = args.metrics
    }

    if (args && args.filters) {
      this.filters = Object.assign(this.filters, args.filters)
    }
    if (args && args.internalFilters) {
      this.internalFilters = Object.assign(this.internalFilters, args.internalFilters)
    }

    if (args && args.rightCol) {
      this.rightCol = args.rightCol
    }

    if (args && args.leftCol) {
      this.leftCol = args.leftCol
    }

    if (args && args.size) {
      this.size = args.size
    }

    if (args && args.title) {
      this.title = args.title
    }

    if (args && args.key) {
      this.key = args.key
    }

    if (args && args.noPagination) {
      this.noPagination = args.noPagination
    }

    if (args && args.updateFields) {
      this.fields = args.updateFields(this.fields)
    }

    if (args && args.target) {
      this.target = args.target
    }
  }

  public fields = [
    {
      key: 'label',
      label: 'Label',
      class: 'text-center align-middle text-capitalize',
      show: true,
      thClass: 'align-middle text-center',
      sortable: false,
    },
    {
      key: 'last_year',
      label: 'Last Year',
      class: 'text-center align-middle',
      show: true,
      thClass: 'align-middle text-center',
      type: 'currency',
      sortable: false,
      total: 'currency',
      customTotal: (data: any) =>
        data.reduce((acc: number, row: any) => acc + Number(row.last_year), 0) / data.length,
    },
    {
      key: 'ytd',
      label: 'YTD',
      class: 'text-center align-middle',
      show: true,
      thClass: 'align-middle text-center',
      type: 'currency',
      sortable: false,
      total: 'currency',
      customTotal: (data: any) =>
        data.reduce((acc: number, row: any) => acc + Number(row.ytd), 0) / data.length,
    },
  ]

  public dimensions: string[] = ['region']

  public metrics: string[] = ['pipeline_amount', 'pipeline_amount']

  public size: any = {
    lg: 6,
    md: 6,
  }

  public loaderSize: string = '350px'

  // API Filters
  public filters: any = {
    region: 'all',
    product: 'all',
    status: ['won', 'processing'],
  }

  public internalQuery: any = ['scope:finance_goal']

  public get payload() {
    const query = [...new Set([...this.query, ...this.internalQuery])]

    return {
      metrics: this.metrics,
      dimensions: this.dimensions,
      query,
      filters: {
        ...this.internalFilters,
      },
    }
  }

  public internalFilters: any = {

  }

  public flattenPayload: boolean = true

  public dataSource() {
    let api = new Api()
    return api.post(`media_plans/cpm_overview/${this.target}`, this.payload).then((res: any) => res.data.result)
  }

  public dataMapper(data: any): Promise<any> {
    data = data.sort((a: any, b: any) => {
      if (a[this.dimensions[0]] < b[this.dimensions[0]]) {
        return -1
      }
      if (a[this.dimensions[0]] > b[this.dimensions[0]]) {
        return 1
      }
      return 0
    })
    // console.log('dataMapper', data)

    return Promise.resolve(data)
  }
}
